import { PauseIcon, PlayIcon } from '@heroicons/react/24/solid';
import WaveSurfer from 'wavesurfer.js';

import AudioWaveform from '@/components/audio-conversation/AudioWaveform';

import { useWaveSurferAudio } from './useWaveSurferAudio';

interface ConversationAudioControlsProps {
  conversation: {
    id: string;
    audio_path?: string | null;
    duration?: string;
  };
  onReady: (ws: WaveSurfer) => void;
  onTimeUpdate: (time: number) => void;
}

/**
 * Mini audio controls tailored for the transcript preview.
 * Provides play / pause & waveform, forwards time updates upstream.
 */
export const ConversationAudioControls = ({
  conversation,
  onReady,
  onTimeUpdate,
}: ConversationAudioControlsProps) => {
  const {
    audioUrl,
    isLoading: isLoadingAudio,
    isPlaying,
    handleWaveformReady,
    togglePlayPause,
  } = useWaveSurferAudio({
    audioPath: conversation.audio_path,
    onTimeUpdate,
  });

  /* ------------------------------ Render ------------------------------ */
  if (!conversation.audio_path) return null;

  return (
    <div className="px-5 py-3 border-b border-gray-100 flex items-center gap-2 bg-white">
      <button
        type="button"
        onClick={togglePlayPause}
        disabled={isLoadingAudio}
        className="p-1 text-gray-500 hover:text-gray-700 hover:bg-gray-100 rounded transition-colors disabled:opacity-50"
      >
        {isLoadingAudio ? (
          <div className="h-4 w-4 border-2 border-gray-200 border-t-transparent rounded-full animate-spin" />
        ) : isPlaying ? (
          <PauseIcon className="h-4 w-4" />
        ) : (
          <PlayIcon className="h-4 w-4" />
        )}
      </button>
      <AudioWaveform
        audioUrl={audioUrl}
        onReady={(ws) => {
          onReady(ws);
          handleWaveformReady(ws);
        }}
        onPlay={() => {}}
        onPause={() => {}}
        isPlaying={isPlaying}
      />
    </div>
  );
};
